const destination = process.env.REACT_APP_INGEST_URL 
	? `${process.env.REACT_APP_INGEST_URL}/loki/api/v1/push` 
	: undefined;

const initialDelay = 1;
const batchSeconds = 15;

type LogLabels = Record<string, string>;
type LogLines = [string, string, Record<string, string>];
type LogStream = { stream: LogLabels, values: LogLines[]};
type LogPost = { streams: LogStream[] };


let timerId: ReturnType<typeof setTimeout> | undefined = undefined;
let logList: LogLines[] = [];
let accessToken: string | undefined = undefined;
let labels: LogLabels = {};

const report = (message: string, data?:Record<string, any>) =>
{
	postMessage({
		type: 'log',
		message,
		data
	});
};

export const setAccessToken = (newAccessToken: string | undefined) =>
{
	report('got an access token!');
	report(destination ?? '');
	accessToken = newAccessToken;
};

export const setLabels = (newLabels: LogLabels) =>
{
	// https://grafana.com/docs/loki/latest/get-started/labels/#format
	labels = Object.fromEntries(Object.entries(newLabels).map(([k,v]) => ([k.replace(/[^A-Za-z0-9_:]+/g, '_'),String(v)])));
};

export const log = (timestamp: Date, message: string, tags: Record<string, string>) => 
{
	if(!destination)
	{
		return;
	}

	// convert our time to nanoseconds
	logList.push([timestamp.getTime().toFixed(0) + '000000', message, Object.fromEntries(Object.entries(tags).map(([k,v]) => ([k.replace(/[^A-Za-z0-9_:]+/g, '_'),String(v)])))]);
	if(!timerId)
	{
		// If this is the first log, we'll commit it pretty quickly
		timerId = setTimeout(flush, initialDelay * 1000);	
	}
};

export const flush = async () =>
{
	if(!destination || !accessToken)
	{
		return;
	}

	// Steal the waiting data
	const batch = logList;
	// Reset the queue so new things get queued here
	logList = [];
	try 
	{
		const body: LogPost = {
			streams: [ {
				stream: labels,
				values: batch
			} ]
		};
		const headers = new Headers({
			'Content-Type': 'application/json',
			'Authorization': `Bearer ${accessToken}`
		});
		const response = await fetch(destination, {
			method: 'POST',
			body: JSON.stringify(body),
			headers: headers
		});
		report(await response.text());
	}
	catch(err)
	{
		report(String(err), err);
	}

	if(logList.length)
	{
		// New content was added, schedule the next batch after a longer delay
		setTimeout(flush, batchSeconds * 1000);	
	}
	else
	{
		// No data waiting, clear the timer
		timerId = undefined;
	}
};